import actionCreatorFactory from 'typescript-fsa'

import {
  GetFacebookPageStatisticsRequest,
  GetInstagramPageStatisticsRequest,
} from '@3m5/sm_publish-frontend-api/apis/NetworkStatisticsApi'

import {
  FacebookPageStatistic,
  InstagramPageStatistic,
} from '@3m5/sm_publish-frontend-api'
import { GetFacebookPostsInRangeForPageRequest } from '@3m5/sm_publish-frontend-api/apis/FacebookPostApi'
import { FacebookPostWithRelativeReach, InstagramPostWithRelativeReach } from '@3m5/sm_publish-frontend-api/models'
import { GetInstagramPostsInRangeForPageRequest } from '@3m5/sm_publish-frontend-api/apis/InstagramPostApi'
const actionCreator = actionCreatorFactory('TOPIC')

/*
 *  Actions
 */
export const getFacebookPageStatisticsInitiated = actionCreator<GetFacebookPageStatisticsRequest>('GET_FACEBOOK_PAGE_STATISTICS_INITIATED')
export const getFacebookPageStatistics = actionCreator.async<GetFacebookPageStatisticsRequest, FacebookPageStatistic[]>('GET_FACEBOOK_PAGE_STATISTICS')

export const getInstagramPageStatisticsInitiated = actionCreator<GetInstagramPageStatisticsRequest>('GET_INSTAGRAM_PAGE_STATISTICS_INITIATED')
export const getInstagramPageStatistics = actionCreator.async<GetInstagramPageStatisticsRequest, InstagramPageStatistic[]>('GET_INSTAGRAM_PAGE_STATISTICS')

export const getFacebookPostsInRangeForPageInitiated = actionCreator<GetFacebookPostsInRangeForPageRequest>('GET_FACEBOOK_POSTS_IN_RANGE_INITIATED')
export const getFacebookPostsInRangeForPage = actionCreator.async<GetFacebookPostsInRangeForPageRequest, FacebookPostWithRelativeReach[]>('GET_FACEBOOK_POSTS_IN_RANGE')

export const getInstagramPostsInRangeForPageInitiated = actionCreator<GetInstagramPostsInRangeForPageRequest>('GET_INSTAGRAM_POSTS_IN_RANGE_INITIATED')
export const getInstagramPostsInRangeForPage = actionCreator.async<GetInstagramPostsInRangeForPageRequest, InstagramPostWithRelativeReach[]>('GET_INSTAGRAM_POSTS_IN_RANGE')
